import { ArrowToTop } from '@styled-icons/boxicons-regular/ArrowToTop'
import styled from 'styled-components'

export const BackToQueueButton = styled(ArrowToTop)`
  width: 34px;
  cursor: inherit;
`

export const Button = styled.button`
  border: none;
  background-color: inherit;
  cursor: pointer;

  color: ${({ disabled }) => (disabled ? '#bbbbbb' : '#25a37b')};
`

export const Wrapper = styled.div.attrs(() => ({
  className: 'table-responsive mt-4',
}))`
  overflow-y: auto;
  height: 550px;
`
